import {
  GET_ALL_DOCUMENTS,
  GET_ALL_DOCUMENTS_ERROR,
  GET_ALL_DOCUMENTS_SUCCESS,
} from "../actions/knowledgebaseActions";

interface KnowledgebaseState {
  contentUnits: unknown[];
  fetchingKnowledgebase: boolean;
  fetchKnowledgebaseComplete: boolean;
  fetchKnowledgebaseError: unknown;
  products?: unknown;
}

interface KnowledgebaseAction {
  type: string;
  payload: {
    data?: unknown;
    products?: unknown;
  };
}

export function knowledgebaseReducer(
    state: KnowledgebaseState = {
      contentUnits: [],
      fetchingKnowledgebase: false,
      fetchKnowledgebaseComplete: false,
      fetchKnowledgebaseError: undefined
    },
    action: KnowledgebaseAction
) {
  switch (action.type) {
    case GET_ALL_DOCUMENTS:
      return Object.assign({}, state, {
        fetchingKnowledgebase: true,
        fetchKnowledgebaseComplete: false,
        fetchKnowledgebaseError: undefined,
      });
    case GET_ALL_DOCUMENTS_SUCCESS:
      return Object.assign({}, state, {
        fetchingKnowledgebase: false,
        fetchKnowledgebaseComplete: true,
        fetchKnowledgebaseError: undefined,
        contentUnits: action.payload.data,
        products: action.payload.products,
      });
    case GET_ALL_DOCUMENTS_ERROR:
      return Object.assign({}, state, {
        fetchingKnowledgebase: false,
        fetchKnowledgebaseComplete: true,
        fetchKnowledgebaseError: action.payload.data,
      });
    default:
      return state;
  }
}